import { createFileRoute } from "@tanstack/react-router";

import type { ChildRouteContext } from "@/root";
import { throwIfHasNoPermission } from "@/utils/permissions";

import EntryForm from "@/modules/handbook/admin/components/EntryForm";

export const Route = createFileRoute(
  "/admin/_panel/_handbook/handbook/entries/create",
)({
  component: Component,
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(context.user, "handbook.handbook-entry.create");

    return {
      crumb: [
        {
          label: context.t("Create", { ns: "core.shared" }),
        },
      ],
    } satisfies ChildRouteContext;
  },
});

function Component() {
  return <EntryForm />;
}
